import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { setCommentListTopInViewport } from "~/store/actions/actions.lastVisit.jsx";
import ElementInViewport from "../ElementInViewport.jsx";

const CommentListTop = ({ parentType, parentId }) => {
  const dispatch = useDispatch();

  const onEnter = useCallback(() => {
    dispatch(setCommentListTopInViewport(parentId, parentType, true));
  }, [dispatch, parentId, parentType]);

  const onExit = useCallback(() => {
    dispatch(setCommentListTopInViewport(parentId, parentType, false));
  }, [dispatch, parentId, parentType]);

  return (
    <ElementInViewport
      onEnter={onEnter}
      onExit={onExit}
    />
  );
};

CommentListTop.propTypes = {
  parentType: PropTypes.string,
  parentId: PropTypes.number,
};

export default CommentListTop;
